module.exports = __webpack_public_path__ + "img/stop.a78bb890.svg";